import { db, dbGlobal } from "@/firebase";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  where,
  orderBy,
  limit
} from "firebase/firestore";

const state = {
  progressData: [],
  leaderBoardData: [],
  tableData: [],
  promotionList: {},
  rewardList: {},
  primaryMenus: [],
  secondaryMenus: [],
  tablesDisplay: [],
  leaderboardsDisplay: []
};

const actions = {
  async getProgressData({ commit, getters }, user) {
    // Add null check for user
    if (!user || !user._id) {
      return;
    }

    const programRef = doc(db(), "programs", getters.programId);
    const leaderboardsRef = collection(programRef, "leaderboards");

    const leaderboardUnsubscribe = onSnapshot(
      query(leaderboardsRef, orderBy("order")),
      querySnapshot => {
        var leaderBoardDataArr = [];
        let currentUserLeaderboardArr = [];
        querySnapshot.forEach(docSnapshot => {
          let leaderBoardData = {
            ...docSnapshot.data(),
            tableId: docSnapshot.id
          };
          if (
            leaderBoardData.status === "Active" ||
            leaderBoardData.status === "active"
          ) {
            let memberTagExist = false;
            if (leaderBoardData.memberTags.length === 0) {
              memberTagExist = true;
            } else {
              memberTagExist = leaderBoardData.memberTags.some(tag => {
                return user.tags && user.tags.includes(tag);
              });
            }
            let companyTagExist = false;
            if (leaderBoardData.companyTags.length === 0) {
              companyTagExist = true;
            } else {
              companyTagExist = leaderBoardData.companyTags.some(tag => {
                return user.companyTags && user.companyTags.includes(tag);
              });
            }
            if (memberTagExist && companyTagExist) {
              const rankMap =
                leaderBoardData.columnMappings.find(
                  item => item.column === "Rank"
                ) || {};
              let updated = false;
              if (leaderBoardData.participantType === "member") {
                leaderBoardData.columnData.map(leaderboardObj => {
                  if (leaderboardObj.id === user._id) {
                    currentUserLeaderboardArr.push({
                      ...leaderboardObj,
                      title: leaderBoardData.title,
                      displayTitle: leaderBoardData.displayTitle,
                      order: leaderBoardData.order,
                      prefix:
                        leaderBoardData.homeMappings &&
                        leaderBoardData.homeMappings.prefix,
                      suffix:
                        leaderBoardData.homeMappings &&
                        leaderBoardData.homeMappings.suffix,
                      cardHeader: leaderBoardData.headerMappings,
                      headerData:
                        leaderBoardData.headerData.find(
                          el => el.id === leaderboardObj.id
                        ) || {},
                      resultsHeader: leaderBoardData.columnMappings,
                      tableId: leaderBoardData.tableId,
                      cardType: "leaderboard",
                      rankValue: leaderboardObj.values[rankMap.uid],
                      iconToRender: leaderBoardData.iconMappings || {},
                      data: leaderBoardData.columnData,
                      remarkData:
                        leaderBoardData.remarkData.find(
                          el => el.id === leaderboardObj.id
                        ) || {},
                      remarkMappings: leaderBoardData.remarkMappings
                    });
                    updated = true;
                  }
                });
              } else {
                leaderBoardData.columnData.map(leaderboardObj => {
                  user.companies.map(companyId => {
                    if (leaderboardObj.id === companyId) {
                      currentUserLeaderboardArr.push({
                        ...leaderboardObj,
                        title: leaderBoardData.title,
                        displayTitle: leaderBoardData.displayTitle,
                        order: leaderBoardData.order,
                        prefix:
                          leaderBoardData.homeMappings &&
                          leaderBoardData.homeMappings.prefix,
                        suffix:
                          leaderBoardData.homeMappings &&
                          leaderBoardData.homeMappings.suffix,
                        cardHeader: leaderBoardData.headerMappings,
                        headerData:
                          leaderBoardData.headerData.find(
                            el => el.id === leaderboardObj.id
                          ) || {},
                        resultsHeader: leaderBoardData.columnMappings,
                        tableId: leaderBoardData.tableId,
                        cardType: "leaderboard",
                        rankValue: leaderboardObj.values[rankMap.uid],
                        iconToRender: leaderBoardData.iconMappings || {},
                        data: leaderBoardData.columnData,
                        remarkData:
                          leaderBoardData.remarkData.find(
                            el => el.id === leaderboardObj.id
                          ) || {},
                        remarkMappings: leaderBoardData.remarkMappings || {}
                      });
                      updated = true;
                    }
                  });
                });
              }
              if (!updated) {
                currentUserLeaderboardArr.push({
                  title: leaderBoardData.title,
                  displayTitle: leaderBoardData.displayTitle,
                  order: leaderBoardData.order,
                  prefix:
                    leaderBoardData.homeMappings &&
                    leaderBoardData.homeMappings.prefix,
                  suffix:
                    leaderBoardData.homeMappings &&
                    leaderBoardData.homeMappings.suffix,
                  cardHeader: leaderBoardData.headerMappings,
                  headerData: null,
                  resultsHeader: leaderBoardData.columnMappings,
                  tableId: leaderBoardData.tableId,
                  cardType: "leaderboard",
                  rankValue: null,
                  iconToRender: leaderBoardData.iconMappings || {},
                  data: leaderBoardData.columnData,
                  remarkData: {},
                  remarkMappings: leaderBoardData.remarkMappings
                });
              }
            }
            leaderBoardDataArr.push(leaderBoardData);
          }
        });
        commit("setLeaderBoardData", currentUserLeaderboardArr);
      },
      error => {
        console.log(error);
        if (leaderboardUnsubscribe) {
          leaderboardUnsubscribe();
        }
      }
    );

    const tablesRef = collection(programRef, "tables");
    const tableUnsubscribe = onSnapshot(
      query(tablesRef, orderBy("order")),
      querySnapshot => {
        let currentUserResultData = [];
        var resultDataArray = [];
        querySnapshot.forEach(docSnapshot => {
          let resultData = {
            ...docSnapshot.data(),
            tableId: docSnapshot.id
          };
          if (
            resultData.status === "Active" ||
            resultData.status === "active"
          ) {
            let memberTagExist = false;
            if (resultData.memberTags.length === 0) {
              memberTagExist = true;
            } else {
              memberTagExist = resultData.memberTags.some(tag => {
                return user.tags && user.tags.includes(tag);
              });
            }
            let companyTagExist = false;
            if (resultData.companyTags.length === 0) {
              companyTagExist = true;
            } else {
              companyTagExist = resultData.companyTags.some(tag => {
                return user.companyTags && user.companyTags.includes(tag);
              });
            }
            if (memberTagExist && companyTagExist) {
              if (resultData.participantType === "member") {
                if (Array.isArray(resultData.tableData)) {
                  resultData.tableData.map(resultObj => {
                    if (resultObj.companyId === user._id) {
                      currentUserResultData.push({
                        ...resultObj,
                        title: resultData.title,
                        displayTitle: resultData.displayTitle,
                        order: resultData.order,
                        prefix: resultData.homeCard.prefix,
                        suffix: resultData.homeCard.suffix,
                        cardHeader: resultData.cardHeader,
                        resultsHeader: resultData.resultsHeader,
                        tableId: resultData.tableId
                      });
                    }
                  });
                }
              } else {
                if (user.companies && Array.isArray(user.companies)) {
                  if (Array.isArray(resultData.tableData)) {
                    user.companies.map((company, index) => {
                      resultData.tableData.map(resultObj => {
                        if (resultObj.companyId === company) {
                          currentUserResultData.push({
                            ...resultObj,
                            title: resultData.title,
                            displayTitle: resultData.displayTitle,
                            order: resultData.order,
                            prefix: resultData.homeCard.prefix,
                            suffix: resultData.homeCard.suffix,
                            cardHeader: resultData.cardHeader,
                            resultsHeader: resultData.resultsHeader,
                            tableId: resultData.tableId
                          });
                        }
                      });
                    });
                  }
                }
              }
            }
            resultDataArray.push(resultData);
          }
        });
        commit("setTableData", currentUserResultData);
      },
      error => {
        console.log(error);
        if (tableUnsubscribe) {
          tableUnsubscribe();
        }
      }
    );
  },

  async getPromotionList({ commit, getters }, user) {
    // Add null check for user
    if (!user) {
      commit("setPromotionList", {});
      return;
    }

    const programRef = doc(db(), "programs", getters.programId);

    try {
      let promotionList = {};

      const articlesRef = collection(programRef, "articles");
      const articlesQuery = query(
        articlesRef,
        where("status", "==", "Active"),
        orderBy("updated", "desc"),
        limit(20)
      );
      const articlesSnapshot = await getDocs(articlesQuery);

      if (articlesSnapshot.empty) {
        commit("setPromotionList", {});
        return;
      }

      const blogsRef = collection(programRef, "blogs");
      const blogsSnapshot = await getDocs(blogsRef);
      const blogs = {};
      blogsSnapshot.forEach(docSnapshot => {
        blogs[docSnapshot.id] = docSnapshot.data();
      });

      const blogTitles = {};
      Object.keys(blogs).forEach(blogId => {
        blogTitles[blogId] = blogs[blogId].title || `Blog ${blogId}`;
      });

      const articlesByBlog = {};
      const createrObj = {};

      articlesSnapshot.forEach(docSnapshot => {
        const blogData = docSnapshot.data();
        const blogId = blogData.blog;
        const creater = blogData.updatedBy;

        if (!blogs[blogId]) {
          return;
        }

        let memberTagExist = false;
        if (!blogData.memberTags || blogData.memberTags.length === 0) {
          memberTagExist = true;
        } else {
          memberTagExist = blogData.memberTags.some(tag => {
            return user.tags && user.tags.includes(tag);
          });
        }

        let companyTagExist = false;
        if (!blogData.companyTags || blogData.companyTags.length === 0) {
          companyTagExist = true;
        } else {
          companyTagExist = blogData.companyTags.some(tag => {
            return user.companyTags && user.companyTags.includes(tag);
          });
        }

        if (memberTagExist && companyTagExist) {
          if (!articlesByBlog[blogId]) {
            articlesByBlog[blogId] = [];
          }

          articlesByBlog[blogId].push({
            ...blogData,
            id: docSnapshot.id,
            authorId: creater
          });

          if (!(creater in createrObj)) {
            createrObj[creater] = {};
          }
        }
      });

      const userFetchRequests = Object.keys(createrObj).map(creater =>
        getDoc(doc(dbGlobal, "admins", creater))
      );

      const userDocs = await Promise.all(userFetchRequests);
      userDocs.forEach(docSnapshot => {
        const user = docSnapshot.data();
        if (user) {
          createrObj[user.userId] = user;
        }
      });

      Object.keys(articlesByBlog).forEach(blogId => {
        promotionList[blogId] = articlesByBlog[blogId].map(el => ({
          ...el,
          author: createrObj[el.authorId] ? createrObj[el.authorId].name : "",
          created: el.created.toDate(),
          updated: el.updated.toDate(),
          blogTitle: blogTitles[blogId]
        }));
      });

      commit("setPromotionList", promotionList);
    } catch (error) {
      console.error("Error in getPromotionList:", error);
      commit("setPromotionList", {});
    }
  },

  async getRewardList({ commit, getters }, user) {
    // Add null check for user
    if (!user) {
      commit("setRewardList", {});
      return;
    }

    const programRef = doc(db(), "programs", getters.programId);
    const rootUnsubscribe = onSnapshot(
      programRef,
      querySnapshot => {
        let allData = querySnapshot.data();
        let homeRewardCatalogueIds =
          allData.homeRewardCatalogues.rewardCatalogues || {};
        let rewardList = {};
        if (homeRewardCatalogueIds.length !== 0) {
          homeRewardCatalogueIds.map(async (id, index) => {
            await new Promise((resolve, reject) => {
              const rewardsRef = collection(programRef, "rewards");
              const rewardsQuery = query(
                rewardsRef,
                orderBy("updated", "desc"),
                where("rewardCatalogue", "==", id),
                where("status", "==", "Active")
              );

              const rewardUnsubscribe = onSnapshot(
                rewardsQuery,
                async querySnapshot => {
                  const rewardCatalogueDataArr = [];
                  const createrObj = {};
                  querySnapshot.forEach(docSnapshot => {
                    let rewardCatalogueData = docSnapshot.data();
                    let creater = rewardCatalogueData.updatedBy;
                    let tags = [];

                    let memberTagExist = false;
                    if (rewardCatalogueData.memberTags.length === 0) {
                      memberTagExist = true;
                    } else {
                      memberTagExist = rewardCatalogueData.memberTags.some(
                        tag => {
                          return user.tags && user.tags.includes(tag);
                        }
                      );
                    }
                    let companyTagExist = false;
                    if (rewardCatalogueData.companyTags.length === 0) {
                      companyTagExist = true;
                    } else {
                      companyTagExist = rewardCatalogueData.companyTags.some(
                        tag => {
                          return (
                            user.companyTags && user.companyTags.includes(tag)
                          );
                        }
                      );
                    }
                    if (
                      memberTagExist &&
                      companyTagExist &&
                      rewardCatalogueDataArr.length < 10
                    ) {
                      rewardCatalogueData.rewardCategories.map(eachTagInfo => {
                        const rewardCategoriesRef = collection(
                          programRef,
                          "rewardCategories"
                        );
                        const rewardCategoryUnsubscribe = onSnapshot(
                          doc(rewardCategoriesRef, eachTagInfo),
                          querySnapshot => {
                            tags.push(querySnapshot.data().title);
                          },
                          error => {
                            console.log(error);
                            if (rewardCategoryUnsubscribe) {
                              rewardCategoryUnsubscribe();
                            }
                          }
                        );
                        rewardCatalogueData.tagsToRender = tags;
                      });

                      rewardCatalogueData.authorId = creater;
                      rewardCatalogueData.id = docSnapshot.id;
                      rewardCatalogueDataArr.push(rewardCatalogueData);
                      if (!(creater in createrObj)) {
                        createrObj[creater] = {};
                      }
                    }
                  });

                  const userFetchRequests = Object.keys(
                    createrObj
                  ).map(creater => getDoc(doc(dbGlobal, "admins", creater)));
                  const userDocs = await Promise.all(userFetchRequests);
                  userDocs.forEach(docSnapshot => {
                    const user = docSnapshot.data();
                    if (user) {
                      createrObj[user.userId] = user;
                    }
                  });

                  if (rewardList.hasOwnProperty(id)) {
                    rewardList[id] = rewardCatalogueDataArr.map(el => ({
                      ...el,
                      author: createrObj[el.authorId]
                        ? createrObj[el.authorId].name
                        : "",
                      created: el.created.toDate()
                    }));
                  } else {
                    const payload = {
                      [id]: rewardCatalogueDataArr.map(el => ({
                        ...el,
                        author: createrObj[el.authorId]
                          ? createrObj[el.authorId].name
                          : "",
                        created: el.created.toDate()
                      }))
                    };
                    rewardList = {
                      ...rewardList,
                      ...payload
                    };
                  }
                  commit("setRewardList", rewardList);
                  resolve();
                },
                error => {
                  console.log(error.nativeErrorMessage);
                  reject(error.nativeErrorMessage);
                  if (rewardUnsubscribe) {
                    rewardUnsubscribe();
                  }
                }
              );
            });
          });
        }
      },
      err => {
        console.log(err, "err --- rewardList");
        if (rootUnsubscribe) {
          rootUnsubscribe();
        }
      }
    );
  },

  async getPrimaryMenus({ commit, getters }, user) {
    // Add null check for user
    if (!user) {
      commit("setPrimaryMenus", []);
      return;
    }

    const programRef = doc(db(), "programs", getters.programId);
    const primaryMenusRef = collection(programRef, "primaryMenus");

    const menuUnsubscribe = onSnapshot(
      query(primaryMenusRef, where("status", "==", "Active")),
      querySnapshot => {
        let primaryMenusArray = [];
        let tempArray = [];
        querySnapshot.forEach(docSnapshot => {
          const menuData = { ...docSnapshot.data(), id: docSnapshot.id };
          tempArray.push(menuData);
        });

        tempArray.forEach(async docData => {
          let primaryMenu = docData;

          // Add all menus to the array immediately to avoid race conditions
          const menuIndex = primaryMenusArray.findIndex(
            el => el.id === primaryMenu.id
          );
          if (menuIndex === -1) {
            primaryMenusArray.push(primaryMenu);
          } else {
            primaryMenusArray[menuIndex] = primaryMenu;
          }

          // Sort the array by order
          primaryMenusArray.sort((a, b) =>
            a.order > b.order ? 1 : b.order > a.order ? -1 : 0
          );

          let blogIdToCompare = primaryMenu.content;
          if (primaryMenu.contentType === "Blog") {
            const blogsRef = collection(programRef, "blogs");
            const blogUnsubscribe = onSnapshot(
              doc(blogsRef, primaryMenu.content),
              querySnapshot => {
                let eachBlog = querySnapshot.data();

                if (!eachBlog) {
                  console.warn(
                    "getPrimaryMenus: Blog data not found for",
                    primaryMenu.content
                  );
                  // Mark as hidden if blog data not found
                  const currentMenuIndex = primaryMenusArray.findIndex(
                    el => el.id === primaryMenu.id
                  );
                  if (currentMenuIndex !== -1) {
                    primaryMenusArray[currentMenuIndex].hidden = true;
                    if (primaryMenusArray.length === tempArray.length) {
                      commit("setPrimaryMenus", primaryMenusArray);
                    }
                  }
                  return;
                }

                primaryMenu.screenTitle = eachBlog.title;
                primaryMenu.blogs = {};
                let blogMemberTagExist = false;
                if (eachBlog.memberTags.length === 0) {
                  blogMemberTagExist = true;
                } else {
                  blogMemberTagExist = eachBlog.memberTags.some(tag => {
                    return user.tags && user.tags.includes(tag);
                  });
                }

                let blogCompanyTagExist = false;
                if (eachBlog.companyTags.length === 0) {
                  blogCompanyTagExist = true;
                } else {
                  blogCompanyTagExist = eachBlog.companyTags.some(tag => {
                    return user.companyTags && user.companyTags.includes(tag);
                  });
                }

                if (blogMemberTagExist && blogCompanyTagExist) {
                  primaryMenu.hidden = false;
                } else {
                  primaryMenu.hidden = true;
                }

                // Update the menu in the array
                const currentMenuIndex = primaryMenusArray.findIndex(
                  el => el.id === primaryMenu.id
                );
                if (currentMenuIndex !== -1) {
                  primaryMenusArray[currentMenuIndex] = primaryMenu;
                }

                // Commit if all menus are processed
                if (primaryMenusArray.length === tempArray.length) {
                  commit("setPrimaryMenus", primaryMenusArray);
                }
              },
              error => {
                console.log(error);
                if (blogUnsubscribe) {
                  blogUnsubscribe();
                }
              }
            );
          } else if (primaryMenu.contentType === "Reward Catalogue") {
            // Update the menu in the array immediately
            const currentMenuIndex = primaryMenusArray.findIndex(
              el => el.id === primaryMenu.id
            );
            if (currentMenuIndex !== -1) {
              primaryMenusArray[currentMenuIndex] = primaryMenu;
            }

            // Commit if all menus are processed
            if (primaryMenusArray.length === tempArray.length) {
              commit("setPrimaryMenus", primaryMenusArray);
            }
          } else if (primaryMenu.contentType === "Custom Page") {
            const pageUnsubscribe = onSnapshot(
              doc(collection(programRef, "pages"), primaryMenu.content),
              pageQuerySnapshot => {
                let pageData = pageQuerySnapshot.data();

                if (!pageData) {
                  console.warn(
                    "getPrimaryMenus: Custom Page data not found for",
                    primaryMenu.content
                  );
                  // Mark as hidden if page data not found
                  const currentMenuIndex = primaryMenusArray.findIndex(
                    el => el.id === primaryMenu.id
                  );
                  if (currentMenuIndex !== -1) {
                    primaryMenusArray[currentMenuIndex].hidden = true;
                    if (primaryMenusArray.length === tempArray.length) {
                      commit("setPrimaryMenus", primaryMenusArray);
                    }
                  }
                  return;
                }

                let memberTagExist = false;
                if (!pageData.memberTags || pageData.memberTags.length === 0) {
                  memberTagExist = true;
                } else {
                  memberTagExist = pageData.memberTags.some(tag => {
                    return user.tags && user.tags.includes(tag);
                  });
                }

                let companyTagExist = false;
                if (!pageData.companyTags || pageData.companyTags.length === 0) {
                  companyTagExist = true;
                } else {
                  companyTagExist = pageData.companyTags.some(tag => {
                    return user.companyTags && user.companyTags.includes(tag);
                  });
                }

                const item =
                  memberTagExist && companyTagExist
                    ? { ...primaryMenu, pageData }
                    : { ...primaryMenu, pageData, hidden: true };

                // Update the menu in the array
                const currentMenuIndex = primaryMenusArray.findIndex(
                  el => el.id === item.id
                );
                if (currentMenuIndex !== -1) {
                  primaryMenusArray[currentMenuIndex] = item;
                }

                if (primaryMenusArray.length === tempArray.length) {
                  commit("setPrimaryMenus", primaryMenusArray);
                }
              },
              error => {
                console.log(error);
                if (pageUnsubscribe) {
                  pageUnsubscribe();
                }
              }
            );
          } else {
            // For System Page and other content types, just commit if all menus are processed
            if (primaryMenusArray.length === tempArray.length) {
              commit("setPrimaryMenus", primaryMenusArray);
            }
          }
        });
      },
      error => {
        console.log(error);
        if (menuUnsubscribe) {
          menuUnsubscribe();
        }
      }
    );
  },

  async getSecondaryMenus({ commit, getters }, user) {
    // Add null check for user
    if (!user) {
      commit("setSecondaryMenus", []);
      return;
    }

    const programRef = doc(db(), "programs", getters.programId);
    const menuUnsubscribe = onSnapshot(
      collection(programRef, "menus"),
      querySnapshot => {
        let secondaryMenus = [];
        querySnapshot.forEach(docSnapshot => {
          let menu = {
            ...docSnapshot.data(),
            id: docSnapshot.id
          };
          if (menu.contentType === "Custom Page") {
            const pageUnsubscribe = onSnapshot(
              doc(collection(programRef, "pages"), menu.content),
              pageQuerySnapshot => {
                const pageData = pageQuerySnapshot.data();
                if (pageData) {
                  let memberTagExist = false;
                  if (!pageData.memberTags || pageData.memberTags.length === 0) {
                    memberTagExist = true;
                  } else {
                    memberTagExist = pageData.memberTags.some(tag => {
                      return user.tags && user.tags.includes(tag);
                    });
                  }
                  let companyTagExist = false;
                  if (!pageData.companyTags || pageData.companyTags.length === 0) {
                    companyTagExist = true;
                  } else {
                    companyTagExist = pageData.companyTags.some(tag => {
                      return user.companyTags && user.companyTags.includes(tag);
                    });
                  }
                  if (memberTagExist && companyTagExist) {
                    const index = secondaryMenus.findIndex(
                      item => item.id === menu.id
                    );
                    const menuWithPageData = { ...menu, pageData };
                    if (index === -1) {
                      secondaryMenus.push(menuWithPageData);
                    } else {
                      secondaryMenus[index] = menuWithPageData;
                    }
                    secondaryMenus.sort((a, b) =>
                      a.order > b.order ? 1 : b.order > a.order ? -1 : 0
                    );
                    commit("setSecondaryMenus", [...secondaryMenus]);
                  } else {
                    const index = secondaryMenus.findIndex(
                      item => item.content === menu.content
                    );
                    if (index !== -1) {
                      secondaryMenus.splice(index, 1);
                      secondaryMenus.sort((a, b) =>
                        a.order > b.order ? 1 : b.order > a.order ? -1 : 0
                      );
                    }

                    commit("setSecondaryMenus", [...secondaryMenus]);
                  }
                }
              },
              error => {
                console.log(error);
                if (pageUnsubscribe) {
                  pageUnsubscribe();
                }
              }
            );
          } else if (menu.contentType === "Custom Template") {
            // Custom templates don't need tag checking - they are standalone
            const index = secondaryMenus.findIndex(item => item.id === menu.id);
            if (index === -1) {
              secondaryMenus.push(menu);
            } else {
              secondaryMenus[index] = menu;
            }
            secondaryMenus.sort((a, b) =>
              a.order > b.order ? 1 : b.order > a.order ? -1 : 0
            );
            commit("setSecondaryMenus", [...secondaryMenus]);
          } else if (
            menu.contentType === "System Page" ||
            menu.contentType === "Basic Page"
          ) {
            // System pages and basic pages are always visible
            const index = secondaryMenus.findIndex(item => item.id === menu.id);
            if (index === -1) {
              secondaryMenus.push(menu);
            } else {
              secondaryMenus[index] = menu;
            }
            secondaryMenus.sort((a, b) =>
              a.order > b.order ? 1 : b.order > a.order ? -1 : 0
            );
            commit("setSecondaryMenus", [...secondaryMenus]);
          } else if (menu.contentType === "Blog") {
            let blogIdToCompare = menu.content;
            const blogUnsubscribe = onSnapshot(
              doc(collection(programRef, "blogs"), menu.content),
              querySnapshot => {
                let eachBlog = querySnapshot.data();
                let blogMemberTagExist = false;
                if (eachBlog.memberTags.length === 0) {
                  blogMemberTagExist = true;
                } else {
                  blogMemberTagExist = eachBlog.memberTags.some(tag => {
                    return user.tags && user.tags.includes(tag);
                  });
                }
                let blogCompanyTagExist = false;
                if (eachBlog.companyTags.length === 0) {
                  blogCompanyTagExist = true;
                } else {
                  blogCompanyTagExist = eachBlog.companyTags.some(tag => {
                    return user.companyTags && user.companyTags.includes(tag);
                  });
                }
                if (blogMemberTagExist && blogCompanyTagExist) {
                  menu.hidden = false;
                } else {
                  menu.hidden = true;
                }
                menu.screenTitle = eachBlog.title;
                menu.blogs = {};
                const articleUnsubscribe = onSnapshot(
                  query(
                    collection(programRef, "articles"),
                    where("blog", "==", blogIdToCompare),
                    where("status", "==", "Active"),
                    orderBy("updated", "desc")
                  ),
                  async articleQuerySnapshot => {
                    let articleArray = {};
                    let dynamicCategoriesArray = [];
                    const categoryUnsubscribe = onSnapshot(
                      collection(programRef, "categorys"),
                      async categorySnapshot => {
                        try {
                          let temp = [];
                          categorySnapshot.forEach(docData => {
                            temp.push({
                              ...docData.data(),
                              idToCompare: docData.id
                            });
                          });
                          dynamicCategoriesArray = await Promise.all(
                            temp.map(async docItem => {
                              let dynamicCategories = docItem;
                              const creater =
                                dynamicCategories.updatedBy ||
                                dynamicCategories.createdBy;
                              const querySnapshot = await getDoc(
                                doc(dbGlobal, "admins", creater)
                              );
                              let adminObj = querySnapshot.data();
                              dynamicCategories.author = adminObj
                                ? adminObj.name
                                : "";
                              return dynamicCategories;
                            })
                          );
                        } catch (error) {
                          console.log(error);
                          dynamicCategoriesArray = [];
                        }
                        await Promise.all(
                          dynamicCategoriesArray.map(
                            async dynamicCategories => {
                              let articleList = [];
                              let id = 0;
                              let articleData = [];
                              articleQuerySnapshot.forEach(docSnapshot => {
                                articleData.push({
                                  ...docSnapshot.data(),
                                  id: docSnapshot.id
                                });
                              });
                              await Promise.all(
                                articleData.map(async article => {
                                  let memberTagExist = false;
                                  if (article.memberTags.length === 0) {
                                    memberTagExist = true;
                                  } else {
                                    memberTagExist = article.memberTags.some(
                                      tag => {
                                        return (
                                          user.tags && user.tags.includes(tag)
                                        );
                                      }
                                    );
                                  }
                                  let companyTagExist = false;
                                  if (article.companyTags.length === 0) {
                                    companyTagExist = true;
                                  } else {
                                    companyTagExist = article.companyTags.some(
                                      tag => {
                                        return (
                                          user.companyTags &&
                                          user.companyTags.includes(tag)
                                        );
                                      }
                                    );
                                  }
                                  if (
                                    article.categorys &&
                                    article.status === "Active" &&
                                    companyTagExist &&
                                    memberTagExist
                                  ) {
                                    const creater =
                                      article.updatedBy || article.createdBy;
                                    const querySnapshot = await getDoc(
                                      doc(dbGlobal, "admins", creater)
                                    );
                                    let adminObj = querySnapshot.data();
                                    article.author = adminObj
                                      ? adminObj.name
                                      : "";
                                    article.created = article.created.toDate();
                                    article.updated = article.updated.toDate();
                                    article.categorys.map(eachCategory => {
                                      if (
                                        eachCategory ===
                                        dynamicCategories.idToCompare
                                      ) {
                                        dynamicCategories.id = id;
                                        id++;
                                        if (
                                          articleArray.hasOwnProperty(
                                            dynamicCategories.idToCompare
                                          )
                                        ) {
                                          let index = articleArray[
                                            dynamicCategories.idToCompare
                                          ].articleList.findIndex(
                                            el => el.id === article.id
                                          );
                                          if (index === -1) {
                                            articleArray[
                                              dynamicCategories.idToCompare
                                            ].articleList.push({
                                              ...article,
                                              tagsToRender: [
                                                dynamicCategories.title
                                              ]
                                            });
                                            articleArray[
                                              dynamicCategories.idToCompare
                                            ].articleList.sort((a, b) => {
                                              return (
                                                new Date(b.updated) -
                                                new Date(a.updated)
                                              );
                                            });
                                          } else {
                                            articleArray[
                                              dynamicCategories.idToCompare
                                            ].articleList[index] = {
                                              ...article,
                                              tagsToRender: [
                                                dynamicCategories.title
                                              ]
                                            };
                                          }
                                          articleArray[
                                            dynamicCategories.idToCompare
                                          ] = {
                                            ...articleArray[
                                              dynamicCategories.idToCompare
                                            ],
                                            ...dynamicCategories
                                          };
                                        } else {
                                          let index = articleList.findIndex(
                                            el => el.id === article.id
                                          );
                                          if (index === -1) {
                                            articleList.push({
                                              ...article,
                                              tagsToRender: [
                                                dynamicCategories.title
                                              ]
                                            });
                                          } else {
                                            articleList[index] = {
                                              ...article,
                                              tagsToRender: [
                                                dynamicCategories.title
                                              ]
                                            };
                                          }
                                          dynamicCategories.articleList = [
                                            ...articleList
                                          ];
                                          articleArray[
                                            dynamicCategories.idToCompare
                                          ] = {
                                            ...dynamicCategories
                                          };
                                        }
                                      }
                                    });
                                  }
                                })
                              );
                              menu.blogs = articleArray;
                            }
                          )
                        );
                        let menuIndex = secondaryMenus.findIndex(
                          el => el.id === menu.id
                        );
                        if (menuIndex === -1) {
                          secondaryMenus.push(menu);
                          secondaryMenus.sort((a, b) =>
                            a.order > b.order ? 1 : b.order > a.order ? -1 : 0
                          );
                          commit("setSecondaryMenus", [...secondaryMenus]);
                        } else {
                          secondaryMenus[menuIndex] = secondaryMenus;
                          commit("setSecondaryMenus", [...secondaryMenus]);
                        }
                      },
                      error => {
                        console.log(
                          error.nativeErrorCode,
                          error.nativeErrorMessage,
                          error.code
                        );
                        if (articleUnsubscribe) {
                          articleUnsubscribe();
                        }
                      }
                    );
                  },
                  error => {
                    console.log(error);
                    if (blogUnsubscribe) {
                      blogUnsubscribe();
                    }
                  }
                );
              },
              error => {
                console.log(error);
                if (blogUnsubscribe) {
                  blogUnsubscribe();
                }
              }
            );
          }
        });
      },
      error => {
        console.log(error);
        if (menuUnsubscribe) {
          menuUnsubscribe();
        }
      }
    );
  },

  async getDatabucketData({ commit, getters }, databucketId) {
    const programRef = doc(db(), "programs", getters.programId);
    const databucketRef = doc(
      collection(programRef, "databuckets"),
      databucketId
    );
    const actualDataRef = collection(databucketRef, "actualData");

    const apiCalls = [getDocs(query(actualDataRef, orderBy("created")))];

    let actualDataSnapshot;

    try {
      [actualDataSnapshot] = await Promise.all(apiCalls);
    } catch (e) {
      throw "Error occured when loading data bucket";
    }

    const actualData = [];
    actualDataSnapshot.forEach(item => {
      const data = item.data();
      actualData.push({
        id: item.id,
        created: data.created.toDate(),
        ...data.data
      });
    });
    commit("setDatabucketData", actualData);
  }
};

const mutations = {
  setDatabucketData(state, payload) {
    state.databucketData = payload;
  },
  setProgressData(state, payload) {
    state.progressData = payload;
  },
  setLeaderBoardData(state, payload) {
    state.leaderBoardData = payload;
  },
  setTableData(state, payload) {
    state.tableData = payload;
  },
  setPromotionList(state, payload) {
    state.promotionList = payload;
  },
  setRewardList(state, payload) {
    state.rewardList = payload;
  },
  setPrimaryMenus(state, payload) {
    state.primaryMenus = payload;
  },
  setSecondaryMenus(state, payload) {
    state.secondaryMenus = payload;
  }
};

const getters = {
  databucketData(state) {
    return state.databucketData;
  },
  progressData(state) {
    return state.progressData;
  },
  leaderBoardData(state) {
    return state.leaderBoardData;
  },
  tableData(state) {
    return state.tableData;
  },
  promotionList(state) {
    return state.promotionList;
  },
  rewardList(state) {
    return state.rewardList;
  },
  primaryMenus(state) {
    return state.primaryMenus;
  },
  secondaryMenus(state) {
    return state.secondaryMenus;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
